export default "__VITE_ASSET__DcR8fecP__"